import styled, { css } from 'styled-components';

// constellation
import {
    Heading,
    mediaMixin,
    spaceMixin,
    token,
} from '@zillow/constellation';

const getMinHeightXL = minHeightXL => css`
        ${mediaMixin('xl', css`
            min-height: ${minHeightXL};
        `)}
    `;

export const StyledConnectedCard = styled.div`
    display: flex;
    flex-direction: column;

    width: 100%;
    padding: ${spaceMixin('sm')};
    background-color: ${token('colors.white')};

    ${mediaMixin('sm', css`
        border: solid 1px ${token('colors.gray200')};
        border-radius: 4px;
    `)}

    ${({ minHeightXL }) => minHeightXL && getMinHeightXL(minHeightXL)}

    /* helps vertically center the spinner */
    .SpinnerContainer {
        flex-grow: 2;
    }
`;

export const StyledHeadingWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    margin-bottom: 20px;
`;

export const StyledHeading = styled(Heading)`
    flex-grow: ${props => props.titleGrow};
    margin-right: ${spaceMixin('sm')};
    font-size: 24px;
    line-height: 32px;

    ${mediaMixin('lg', css`
        font-size: 26px;
    `)}
`;
